import { render, staticRenderFns } from "./ForgetPage.vue?vue&type=template&id=4cfef5c6&scoped=true&"
import script from "./ForgetPage.vue?vue&type=script&lang=js&"
export * from "./ForgetPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPage.vue?vue&type=style&index=0&id=4cfef5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfef5c6",
  null
  
)

export default component.exports